import { render, staticRenderFns } from "./AddItemWatchlist.vue?vue&type=template&id=ec38ac4e&scoped=true"
import script from "./AddItemWatchlist.vue?vue&type=script&lang=js"
export * from "./AddItemWatchlist.vue?vue&type=script&lang=js"
import style0 from "./AddItemWatchlist.vue?vue&type=style&index=0&id=ec38ac4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec38ac4e",
  null
  
)

export default component.exports